import React from "react";
import { QuizWrapper } from "~shared/components/QuizWrapper";
import { QuizTest } from "~/modules/QuizTest";

const Theme16Task1 = () => {
  const questions: { question: string; answer: "Да" | "Нет" }[] = [
    {
      question: "Царь Фёдор Иоанович окружил город ещё тремя крепостями?",
      answer: "Нет"
    },
    {
      question: "Алексеевская башня стояла у Крымского брода через Москву-реку?",
      answer: "Да"
    },
    {
      question: "Город по сравнению с Кремлём при Борисе Годунове увеличился в 20 раз? ",
      answer: "Да"
    }
  ];
  return (
    <QuizWrapper
      title='Тест'
      icon='test'
      subtitle='Отметь верные утверждения.'
      description='Выбери правильные ответы'
      successIcon='nast-1'
    >
      <QuizTest questions={questions} />
    </QuizWrapper>
  );
};

export default Theme16Task1;
